import {
  del,
  get,
  post,
  put
} from '../../common/services/api.service';

import {
  API_URL,
  DOWNLOAD,
  MESSAGES_ENDPOINT
  /**
  * VALIDATE_FILENAME
  * */
} from '../../constants/api';
import { EMPTY_STRING, LOCAL_STORE_AUTH_TOKEN, SORT_DATE_CREATED_DESC, ALERT_ERROR, MAX_FILES } from '../../constants/constants';
import commonStore from '../../common/stores/common.store';

/**
 * Class representing files service.
 * */
class FilesService {

  /**
   * Gets all files.
   * @param {object} params - The filter params object.
   * @return {object} Promise - The http call promise.
   * */
  load = (params) => {
    const authToken = localStorage.getItem(LOCAL_STORE_AUTH_TOKEN);
    if (!params) {
      return get(`${API_URL}${MESSAGES_ENDPOINT}`, authToken);
    }

    let query = EMPTY_STRING;
    Object.entries(params).forEach(([key, value]) => {
      query += `${key}=${value}&`;
    });
    return get(`${API_URL}${MESSAGES_ENDPOINT}/?${query}`, authToken);
  }

  /**
   * Gets file details by id.
   * @param {number} id - The file id.
   * @return {object} Promise - The http call promise.
   * */
  loadById = (id) => {
    const authToken = localStorage.getItem(LOCAL_STORE_AUTH_TOKEN);
    return get(`${API_URL}${MESSAGES_ENDPOINT}/${id}`, authToken);
  };

  /**
   * Get download URL by id
   * @param {number} id - the ID of the entity for which you want the URL
   * @returns {Object} Promise - the download URL promise
   */
  downloadById = (id) => {
    const authToken = localStorage.getItem(LOCAL_STORE_AUTH_TOKEN);
    return post(`${API_URL}${MESSAGES_ENDPOINT}/${id}${DOWNLOAD}`, authToken);
  }

  /**
   * Updates the file.
   * @param {object} formData - The updated file.
   * @param {number} id - The file id.
   * @return {object} Promise - The http call promise.
   * */
  saveFileDetails = (formData, id) => {
    const authToken = localStorage.getItem(LOCAL_STORE_AUTH_TOKEN);
    return put(`${API_URL}${MESSAGES_ENDPOINT}/${id}`, authToken, formData);
  }

  /**
   * Create new message.
   * @param {object} message - The message to create.
   * @return {object} Promise - The http call promise.
   * */
  create = async (message) => {

    let all_files;
    all_files = await this.load({limit:0});

    if(all_files.length >= 200) {
      commonStore.show(MAX_FILES, ALERT_ERROR);
      commonStore.hideSpinner();
      return false;
    }
    const authToken = localStorage.getItem(LOCAL_STORE_AUTH_TOKEN);
    return post(`${API_URL}${MESSAGES_ENDPOINT}`, authToken, message);
  };

  /**
   * Remove message by id.
   * @param {number} id - The message id.
   * @return {object} Promise - The http call promise.
   * */
  remove = (id) => {
    const authToken = localStorage.getItem(LOCAL_STORE_AUTH_TOKEN);
    return del(`${API_URL}${MESSAGES_ENDPOINT}/${id}`, authToken);
  }

  /**
   * Uploads a fie to reset url.
   * @param {object} file - The uploaded file.
   * @param {string} url - The upload url.
   * @return {object} Promise - The http call promise.
   * */
  upload = (file, url) => post(url, null, file, true);

  /**
   * Validate file name and return suggested free name
   * @param {string} fileName - the file name to validate
   * @returns {Object} Promise - the available file name
   */
  
  validateName = async (name, id, extension) => {
    let treated_name;
    let clean_name;
    let all_files;
    let i;
    let i2;
    /**
    * This api call never worked
    * const authToken = localStorage.getItem(LOCAL_STORE_AUTH_TOKEN);
    * return post(`${API_URL}${MESSAGES_ENDPOINT}${VALIDATE_FILENAME}`, authToken,
    *   { filename: name });
    */

    treated_name = name.replace(/[^\w\s]/gi, '');
    clean_name = { suggested_filename:treated_name };
  
    all_files = await this.load({sort: SORT_DATE_CREATED_DESC});
    //check if name already exists in files list  
    for (i = 0; i < all_files.length; i++) {
      if(all_files[i]['id'] !== id){
        if(all_files[i]['name'] === treated_name+'.'+extension){
          //default
          clean_name = { suggested_filename:treated_name+'_1' };
          let dupcount = 1;
          for (i2 = 0; i2 < all_files.length; i2++) {
            //check if dup name needs to be incremented
            if(all_files[i2]['name'] === treated_name+'_'+dupcount+'.'+extension){
              dupcount++;
              clean_name = { suggested_filename:treated_name+'_'+dupcount };
              
            }
          }
        }
      }
    }
    return clean_name;
  }

}

export default new FilesService();



// WEBPACK FOOTER //
// ./src/messages/services/files.service.js